 
import { Button, CIActionBtnGroup, Input, MyIcon } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { nonSpaceCharacterRegex } from '../../../../../constants';
import { IHeaderParam, IQueryPathParam } from '../../../../../models/index';
import classes from './ItemHandler.module.scss';

interface IQueryPathParamProps {
  index: number,
  itemKey: string,
  itemValue: string,
  isEdit: boolean | undefined
  isView: boolean;
  updateItem?: (obj: IHeaderParam) => void;
  deleteItem?: (index: number) => void;
  itemList?: IQueryPathParam[];
}
const ItemHandler = ({ index, itemKey, itemValue: value, isEdit, updateItem, deleteItem, isView, itemList: list }: IQueryPathParamProps) => {
  const [paramKey, setParamKey] = useState(itemKey);
  const [paramValue, setParamValue] = useState(value);
  const [editClicked, setEditClicked] = useState(isEdit);
  const [oldKey, setOldKey] = useState('');
  const [oldValue, setOldVaue] = useState('');
  const [keyError, setKeyError] = useState('');
  const [isParamKeyValid, setIsParamKeyValid] = useState<boolean>(true);
  const { t: translate } = useTranslation();

  let paramkeyError;

  // called on click of edit
  const onEditItemHandler = () => {
    setEditClicked(true);
    setOldKey(paramKey);
    setOldVaue(paramValue);
  };

  const SERVICE_VALIDATION_ERRORS = {
    keyExists: translate('service_validation_error.keyExists')
  };

  // Checks if key exists
  useEffect(() => {
    let status = false;
    if (list) {
      status = list.some((item, itemIndex) => item.key === paramKey && itemIndex !== index);
    }
    if (status) {
      setIsParamKeyValid(false);
      paramkeyError = SERVICE_VALIDATION_ERRORS.keyExists;
      setKeyError(paramkeyError);
    } else if (!status) {
      setIsParamKeyValid(true);
      paramkeyError = '';
    }
  }, [paramKey, list]);

  // Enabling/disabling update button based on validation
  const isUpdateItemBtnEnabled = () => !!(isParamKeyValid && paramKey && nonSpaceCharacterRegex.test(paramKey) && paramValue);

  // Called when key of item is changed
  const onItemKeyChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setParamKey(event.target.value);
  };

  // Called when value of item is changed
  const onItemValueChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setParamValue(event.target.value);
  };

  // called on click of update button
  const onUpdateItemHandler = (index: number) => {
    setEditClicked(false);
    if (updateItem) updateItem({ key: paramKey, value: paramValue, index });
  };

  // called on click of delete
  const onDeleteItemHandler = (index: number) => {
    if (deleteItem) deleteItem(index);
  };

  // called on click of cancel
  const onCancelItemHandler = () => {
    setEditClicked(false);
    setParamKey(oldKey);
    setParamValue(oldValue);
  };

  return (
    <div className={classes['query-list']}>
      <Row className={classes['param-body']}>
        <Col sm={5}>{editClicked ? (
          <div>
            <div className={classes['input-on-edit']}><Input
              name="itemParamKey"
              label=""
              placeholder={String(
                translate('service_operation_details_form.header_param_key')
              )}
              onChange={onItemKeyChangeHandler}
              value={paramKey}
              data-testid="item-key"
              error={!isParamKeyValid}
              errorTxt={keyError}
              maxLength={Number.MAX_SAFE_INTEGER}
            />
            </div>
          </div>
        ) : (
          <div className={classes['table-items']}>
            <p className={classes.item} data-testid="item-param-key" title={paramKey}>{paramKey}</p>
          </div>
        )}
        </Col>
        <Col sm={5}>
          {editClicked ? (
            <div>
              <div className={classes['input-on-edit']}><Input
                name="itemParamValue"
                label=""
                placeholder={String(
                  translate('service_operation_details_form.header_param_value')
                )}
                onChange={onItemValueChangeHandler}
                value={paramValue}
                maxLength={Number.MAX_SAFE_INTEGER}
                data-testid="item-value"
              />
              </div>
            </div>
          ) : (
            <div className={classes['table-items']}>

              <p className={classes.item} data-testid="item-param-value" title={paramValue}>{paramValue}</p>
            </div>)}
        </Col>
        {isView ? <Col sm={2} /> : (
          <Col sm={2} className={classes.buttons}>
            {!editClicked ? (
              <span className={classes['edit-buttons']}>

                <CIActionBtnGroup
                  buttons={[
                    {
                      label: 'edit',
                      key: 'editIcon',
                      variant: 'tertiary',
                      onClick: async () => onEditItemHandler(),
                      testId: 'edit-btn'
                    },
                    {
                      label: 'delete',
                      key: 'deleteIcon',
                      variant: 'tertiary',
                      onClick: async () => onDeleteItemHandler(index),
                      testId: 'delete-btn'
                    }]}
                />
              </span>
            ) : (
              <span>
                <Button
                  variant="tertiary"
                  className={classes['update-button']}
                  disabled={!isUpdateItemBtnEnabled()}
                  onClick={() => onUpdateItemHandler(index)}
                  data-testid="update-btn"
                  aria-label="update-btn"
                >
                  <MyIcon name="thinCheckIcon" />
                </Button>
                <Button
                  variant="tertiary"
                  onClick={() => onCancelItemHandler()}
                  data-testid="cancel-btn"
                  className={classes['cancel-button']}
                  aria-label="cancel-btn"
                >
                  <MyIcon name="xMarkLargeIcon" />
                </Button>
              </span>)}
          </Col>)}
      </Row>
    </div>);
};

export default ItemHandler;
